import { createAction, props } from '@ngrx/store';
import { User } from '../models/user.model';
import { SignInCredentials } from '../models/auth.model';

export const signInAttempt = createAction(
  '[Auth] Sign In Attempt',
  props<{ credentials: SignInCredentials }>()
);

export const signInTwoFactorRequired = createAction(
  '[Auth] Sign In Two Factor Required',
  props<{ encryptedUser: string; intermediateToken: string; userCode?: string }>()
);

export const validateTwoFactorAttempt = createAction(
  '[Auth] Validate Two Factor Attempt',
  props<{ codigo: string }>()
);

export const setAuthData = createAction(
  '[Auth] Set Auth Data',
  props<{ user: User; token: string }>()
);

export const signInError = createAction(
  '[Auth] Sign In Error',
  props<{ error: string }>()
);

export const signOut = createAction('[Auth] Sign Out');

export const toggleSidenav = createAction('[Layout] Toggle Sidenav');

export const setSidenavOpened = createAction(
  '[Layout] Set Sidenav Opened',
  props<{ opened: boolean }>()
);
